import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

if (typeof window !== 'undefined') {
  console.warn = function() {};
  console.info = function() {};
  console.error = function() {};
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {});
